import { AutoComplete, Button, Divider } from "antd";
import { LabelledElement } from ".";
import { useState, useEffect } from "react";

export const LabelledAutocomplete = ({
    label = "Search",
    value = "",
    type = "text",
    addable = false,
    onSelect = () => { },
    onAddNew = () => { },
    onSearch = () => { },
    ...props
}) => {
    const [inputValue, setInputValue] = useState(value || "");
    const [isLoading, setIsLoading] = useState(false);

    // Update inputValue when value prop changes
    useEffect(() => {
        setInputValue(value || "");
    }, [value]);

    const handleSelect = (value, option) => {
        setInputValue(value);
        if (onSelect) {
            setIsLoading(true);
            onSelect(value, option);
            setIsLoading(false);
        }
    };

    const handleSearch = (searchText) => {
        setInputValue(searchText);
        if (onSearch) {
            onSearch(searchText);
        }
    };

    return (
        <LabelledElement label={label} type={type}>
            <AutoComplete
                value={inputValue}
                onSelect={handleSelect}
                onSearch={handleSearch}
                onChange={setInputValue}
                variant="filled"
                loading={isLoading}
                notFoundContent={isLoading ? "Loading..." : "No options found"}
                popupClassName="autocomplete-multiline"
                popupRender={(menu) => (
                    <div>
                        {menu}
                        {addable && (
                        <div className="mt-2">
                            <Divider style={{ margin: '0' }} />
                            <Button
                                block
                                type="text"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onAddNew(inputValue);
                                }}
                                className="mt-2">
                                {`Add New ${label}`}
                            </Button>
                        </div>
                        )}
                    </div>
                )}
                {...props}
            />
            <style jsx="true">{`
                .autocomplete-multiline .ant-select-item-option-content {
                    white-space: normal !important;
                    word-wrap: break-word !important;
                    overflow-wrap: break-word !important;
                    line-height: 1.4 !important;
                }
                .autocomplete-multiline .ant-select-item {
                    height: auto !important;
                    min-height: 32px !important;
                    padding: 8px 12px !important;
                }
            `}</style>
        </LabelledElement>
    )
};